<template>
    <div>
        <div v-if="onlyWip === null" class="row mb-4">
            <div v-if="ownedByFilter" class="col-md-3">
                <v-select
                    :options="ownedBy"
                    placeholder="All Vehicles"
                    v-model="filters.ownedBy"
                ></v-select>
            </div>
            <div class="col-md-3 d-flex align-items-center">
                <input v-model="filters.outstandingWip" id="outstanding_wip" type="checkbox" class="form-check-input m-0 me-1">
                <label class="form-label m-0" for="outstanding_wip">Has Outstanding WIP</label>
            </div>
        </div>
        <table ref="table" class="table table-bordered table-striped table-vcenter dataTable">
            <thead>
                <tr>
                    <th v-if="onlyWip === null">Stock Number</th>
                    <th v-if="onlyWip === null">VIN</th>
                    <th>Reg</th>
                    <th>Description</th>
                    <th v-if="onlyWip !== null" class="text-nowrap">WIP Time Cost</th>
                    <th v-if="onlyWip !== null" class="text-nowrap">WIP Parts</th>
                    <th></th>
                </tr>
            </thead>
            <tbody></tbody>
        </table>
    </div>
</template>

<script>
import VSelect from 'vue-select';

export default {
    components: {
        VSelect,
    },

    props: {
        ajaxUrl: String,
        onlyWip: {
            type: String,
            default: null,
        },
        ownedBy: Array,
        ownedByFilter: {
            type: Boolean,
            default: true,
        },
    },

    data () {
        return {
            filters: {
                ownedBy: null,
                outstandingWip: false,
            },
        }
    },

    mounted() {
        if (this.onlyWip !== null) {
            this.filters.ownedBy = this.onlyWip;
            this.filters.outstandingWip = true;
        }

        let columns = [
            {
                data: 'stock_number',
            },
            {
                data: 'vin',
            },
            {
                data: 'reg',
            },
            {
                data: 'description',
            },
            {
                data: 'wip_time_cost',
                className: 'text-end',
                render: (data) => `£${data}`
            },
            {
                data: 'wip_parts',
                className: 'text-end',
                render: (data) => `£${data}`
            },
            {
                data: 'actions',
            },
            { data: 'year', visible: false },
            { data: 'make', visible: false },
            { data: 'model', visible: false },
            { data: 'type', visible: false },
        ];

        let reject = (this.onlyWip === null) ? ['wip_time_cost', 'wip_parts'] : ['stock_number', 'vin'];

        columns = columns.filter((column) => reject.indexOf(column.data) == -1);

        let table = window.jQuery(this.$refs.table).on('preXhr.dt', (e, settings, data) => {
            data.filters = this.filters;
        }).DataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: this.ajaxUrl,
            },
            order: [[0, 'desc']],
            columns: columns
        });

        let adjust = () => {
            this.$refs.table.removeAttribute('style');
            table.columns.adjust();
        };

        if (document.getElementById('customer-vehicles-tab')) {
            document.getElementById('customer-vehicles-tab').addEventListener('shown.bs.tab', adjust);
        }

        table.on('draw', adjust);

        // watch api to use table without saving it to data
        this.$watch(
            'filters',
            () => table.ajax.reload(null, false),
            {
                deep: true
            }
        );
    }
}
</script>
